import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppStateProvider from './appState/AppStateProvider';
import { ColorSchemeScript } from '@mantine/core';
import '@mantine/notifications/styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppStateProvider>
      <ColorSchemeScript />
      <App />
    </AppStateProvider>
  </React.StrictMode>
);


reportWebVitals();
